import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import NavBar from './navbar';
import Footer from './footer';
import UserService from '../service/user.service';

const tg = window.Telegram.WebApp;

export default function PaymentComponent({ orderData, user, region }) {
    const history = useHistory();
    const [settings, setSettings] = useState({ card_payment: 'on', crypto_payment: 'on' });
    const [activeTab, setActiveTab] = useState('card');
    const [cardNum, setCardNum] = useState('');
    const [cardLoading, setCardLoading] = useState(true);

    const amount = orderData?.price || '';

    useEffect(() => {
        if (!orderData || Object.keys(orderData).length === 0) {
            history.goBack();
            return;
        }

        UserService.getPaymentSettings(user.id)
            .then(res => {
                const s = res.data || {};
                setSettings(s);
                if (s.card_payment === 'off' && s.crypto_payment === 'on') {
                    setActiveTab('cryptobot');
                }
            })
            .catch(() => {});

        if (region === 'kz') {
            UserService.getKzCard().then(r => { setCardNum(r.data || ''); setCardLoading(false); }).catch(() => setCardLoading(false));
        } else {
            UserService.getRuCard().then(r => { setCardNum(r.data || ''); setCardLoading(false); }).catch(() => setCardLoading(false));
        }
    }, []);

    if (!orderData || Object.keys(orderData).length === 0) return null;

    const showCard = settings.card_payment !== 'off';
    const showCrypto = settings.crypto_payment === 'on';
    const tabs = [
        showCard && { id: 'card', label: '💳 Карта' },
        showCrypto && { id: 'cryptobot', label: '🤖 CryptoBot' },
        showCrypto && { id: 'usdt', label: '💵 USDT' },
    ].filter(Boolean);

    return (
        <>
            <NavBar text="Оплата"/>
            <div className="payment-page">

                {/* Order summary */}
                <div className="payment-details">
                    <div className="row-item"><span className="key">Модель</span><span className="val">{orderData.name}</span></div>
                    <div className="row-item"><span className="key">Дата и время</span><span className="val">{orderData.date}</span></div>
                    {orderData.adress && <div className="row-item"><span className="key">Адрес</span><span className="val">{orderData.adress}</span></div>}
                    <div className="row-item"><span className="key">Сумма</span><span className="val" style={{ color: 'var(--primary)' }}>{amount} {region === 'kz' ? '₸' : '₽'}</span></div>
                </div>

                {/* Tab switcher */}
                {tabs.length > 1 && (
                    <div className="payment-tabs">
                        {tabs.map(t => (
                            <button
                                key={t.id}
                                className={`payment-tab ${activeTab === t.id ? 'active' : ''}`}
                                onClick={() => setActiveTab(t.id)}
                            >
                                {t.label}
                            </button>
                        ))}
                    </div>
                )}

                {/* Card tab */}
                {activeTab === 'card' && (
                    <CardTab
                        cardNum={cardNum}
                        cardLoading={cardLoading}
                        cardUnavailable={settings.card_payment === 'unavailable'}
                        orderData={orderData}
                        user={user}
                    />
                )}

                {/* CryptoBot tab */}
                {activeTab === 'cryptobot' && (
                    <CryptoBotTab user={user} amount={amount} region={region}/>
                )}

                {/* USDT tab */}
                {activeTab === 'usdt' && (
                    <UsdtTab user={user} amount={amount}/>
                )}
            </div>
            <Footer/>
        </>
    );
}

/* ── Card tab ────────────────────────────────────────────────── */

function CardTab({ cardNum, cardLoading, cardUnavailable, orderData, user }) {
    const fileRef = useRef(null);
    const [uploading, setUploading] = useState(false);
    const [status, setStatus] = useState(null); // 'ok' | 'err' | null
    const [statusMsg, setStatusMsg] = useState('');

    if (cardUnavailable) {
        return (
            <div style={{ textAlign: 'center', padding: '24px 0' }}>
                <div style={{ fontSize: 32, marginBottom: 12 }}>⏸</div>
                <p style={{ fontSize: 15, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 8 }}>Карта временно недоступна</p>
                <p style={{ fontSize: 13, color: 'var(--text-secondary)' }}>Попробуйте другой способ оплаты или свяжитесь с оператором.</p>
            </div>
        );
    }

    const handleFile = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onloadend = () => {
            setUploading(true);
            UserService.uploadCheck({
                photo: reader.result.split(',')[1],
                model_id: orderData.model_id,
                name: orderData.name,
                address: orderData.adress,
                date: orderData.date,
                price: orderData.price,
                user_id: user.id,
            }).then(res => {
                setUploading(false);
                if (res.data?.status) { setStatus('ok'); setStatusMsg('Заказ создан! Ожидайте подтверждения.'); setTimeout(() => tg.close(), 2000); }
                else { setStatus('err'); setStatusMsg(res.data?.msg || 'Ошибка при отправке'); }
            }).catch(err => { setUploading(false); setStatus('err'); setStatusMsg(err.message); });
        };
        reader.readAsDataURL(file);
    };

    return (
        <>
            <p style={{ fontSize: 13, color: 'var(--text-secondary)', margin: '0 0 12px', lineHeight: 1.5 }}>
                Переведите сумму на указанный номер карты, затем загрузите скриншот чека.
            </p>
            <div className="field-label-pay">Номер карты</div>
            <div className="card-number-box">{cardLoading ? '...' : cardNum}</div>
            <div className="field-label-pay">Сумма</div>
            <div className="amount-box">{orderData.price}</div>

            {status === 'ok' && (
                <div style={{ textAlign: 'center', padding: '12px 0', color: 'var(--green)', fontSize: 15, fontWeight: 600 }}>
                    ✓ {statusMsg}
                </div>
            )}
            {status === 'err' && (
                <p style={{ fontSize: 12, color: 'var(--red)', margin: '6px 0' }}>{statusMsg}</p>
            )}

            {status !== 'ok' && (
                <button className="btn-primary" disabled={uploading} onClick={() => fileRef.current.click()}>
                    {uploading ? 'Загрузка...' : '📎 Загрузить чек'}
                </button>
            )}
            <input ref={fileRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleFile}/>
        </>
    );
}

/* ── CryptoBot tab ───────────────────────────────────────────── */

function CryptoBotTab({ user, amount, region }) {
    const [loading, setLoading] = useState(false);
    const [invoiceId, setInvoiceId] = useState(null);
    const [payLink, setPayLink] = useState('');
    const [pollStatus, setPollStatus] = useState('pending');
    const pollRef = useRef(null);

    const create = () => {
        setLoading(true);
        UserService.createCryptoInvoice(user.id, {
            amount,
            currency: region === 'kz' ? 'KZT' : 'RUB',
        }).then(res => {
            setLoading(false);
            const d = res.data || {};
            if (d.invoice_id) {
                setInvoiceId(d.invoice_id);
                setPayLink(d.pay_url || d.payment_link || '');
                startPolling(d.invoice_id);
            }
        }).catch(() => setLoading(false));
    };

    const startPolling = (id) => {
        pollRef.current = setInterval(() => {
            UserService.cryptoInvoiceStatus(user.id, id).then(res => {
                const s = res.data?.status || 'pending';
                if (s === 'paid') {
                    clearInterval(pollRef.current);
                    setPollStatus('paid');
                    setTimeout(() => tg.close(), 2500);
                }
            }).catch(() => {});
        }, 5000);
    };

    useEffect(() => () => clearInterval(pollRef.current), []);

    if (pollStatus === 'paid') {
        return (
            <div className="success-screen">
                <div className="icon">✅</div>
                <h3>Оплата получена!</h3>
                <p>Ваш заказ подтверждён. Ожидайте сообщение в боте.</p>
            </div>
        );
    }

    if (!invoiceId) {
        return (
            <>
                <p style={{ fontSize: 13, color: 'var(--text-secondary)', margin: '0 0 16px', lineHeight: 1.5 }}>
                    Создайте счёт в CryptoBot и оплатите его в приложении. Подтверждение происходит автоматически.
                </p>
                <button className="btn-primary" disabled={loading} onClick={create}>
                    {loading ? 'Создание счёта...' : '🤖 Создать счёт в CryptoBot'}
                </button>
            </>
        );
    }

    return (
        <>
            <p style={{ fontSize: 13, color: 'var(--text-secondary)', margin: '0 0 12px' }}>
                Счёт создан. Нажмите кнопку ниже, чтобы открыть CryptoBot и оплатить.
            </p>
            {payLink && (
                <a href={payLink} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                    <button className="btn-primary" style={{ marginBottom: 12 }}>
                        Оплатить в CryptoBot →
                    </button>
                </a>
            )}
            <p style={{ fontSize: 12, color: 'var(--text-secondary)', textAlign: 'center' }}>
                Ожидаем подтверждение оплаты...
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 8 }}>
                <div style={{
                    width: 20, height: 20,
                    border: '2px solid var(--border)',
                    borderTop: '2px solid var(--primary)',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                }}/>
            </div>
        </>
    );
}

/* ── USDT tab ────────────────────────────────────────────────── */

function UsdtTab({ user, amount }) {
    const [address, setAddress] = useState('');
    const [loading, setLoading] = useState(true);
    const [txHash, setTxHash] = useState('');
    const [amountUsd, setAmountUsd] = useState('');
    const [verifying, setVerifying] = useState(false);
    const [result, setResult] = useState(null); // 'ok' | 'err' | null
    const [resultMsg, setResultMsg] = useState('');
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        UserService.getUsdtAddress(user.id)
            .then(res => { setAddress(res.data?.address || res.data || ''); setLoading(false); })
            .catch(() => setLoading(false));
    }, []);

    const copy = () => {
        navigator.clipboard.writeText(address).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    const verify = () => {
        if (!txHash.trim()) { setResult('err'); setResultMsg('Введите TX hash'); return; }
        if (!amountUsd || isNaN(Number(amountUsd))) { setResult('err'); setResultMsg('Введите сумму в USDT'); return; }
        setVerifying(true); setResult(null);
        UserService.verifyUsdtTx(user.id, { tx_hash: txHash.trim(), expected_amount_usd: Number(amountUsd) })
            .then(res => {
                setVerifying(false);
                if (res.data?.verified) {
                    setResult('ok'); setResultMsg('Оплата подтверждена! Ожидайте сообщение в боте.');
                    setTimeout(() => tg.close(), 2500);
                } else {
                    setResult('err'); setResultMsg(res.data?.message || 'Транзакция не найдена или сумма не совпадает');
                }
            }).catch(err => { setVerifying(false); setResult('err'); setResultMsg(err.message); });
    };

    if (result === 'ok') {
        return (
            <div className="success-screen">
                <div className="icon">✅</div>
                <h3>Оплата подтверждена!</h3>
                <p>Ваш заказ создан. Ожидайте сообщение в боте.</p>
            </div>
        );
    }

    return (
        <>
            <p style={{ fontSize: 13, color: 'var(--text-secondary)', margin: '0 0 12px', lineHeight: 1.5 }}>
                Отправьте USDT TRC-20 на адрес ниже. После перевода введите TX hash и сумму для подтверждения.
            </p>

            <div style={{ fontSize: 11, color: 'var(--text-secondary)', marginBottom: 4 }}>USDT TRC-20 адрес</div>
            <div className="card-number-box" style={{ fontSize: 12, letterSpacing: 0, wordBreak: 'break-all' }}>
                {loading ? '...' : address || 'Адрес не настроен'}
            </div>
            {address && (
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 6, marginBottom: 8 }}>
                    <button className="copy-btn" onClick={copy}>{copied ? '✓ Скопировано' : 'Скопировать адрес'}</button>
                </div>
            )}

            <div style={{ fontSize: 11, color: 'var(--text-secondary)', margin: '12px 0 4px' }}>Сумма USDT</div>
            <input
                className="input-field"
                type="number"
                placeholder="Например: 25.00"
                value={amountUsd}
                onChange={e => setAmountUsd(e.target.value)}
            />

            <div style={{ fontSize: 11, color: 'var(--text-secondary)', margin: '10px 0 4px' }}>TX Hash транзакции</div>
            <input
                className="input-field"
                placeholder="0x..."
                value={txHash}
                onChange={e => setTxHash(e.target.value)}
            />

            {result === 'err' && (
                <p style={{ fontSize: 12, color: 'var(--red)', margin: '8px 0' }}>{resultMsg}</p>
            )}

            <button className="btn-primary" style={{ marginTop: 12 }} disabled={verifying} onClick={verify}>
                {verifying ? 'Проверка...' : 'Подтвердить оплату'}
            </button>
        </>
    );
}
